var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "translation_box" }, [
    _c("div", {
      staticClass: "translation_box_btn el-icon-refresh",
      on: { click: _vm.clickTranslation },
    }),
    _c(
      "div",
      { ref: "translationBoxContent", staticClass: "translation_box_content" },
      [
        !_vm.translationInfoShow
          ? _c("div", [_vm._v(_vm._s(_vm.info))])
          : _c("div", [_vm._v(_vm._s(_vm.translationInfo))]),
      ]
    ),
    _vm.translationIng
      ? _c("div", { staticClass: "loading " }, [
          _c("span", {
            staticClass: "el-icon-loading",
            staticStyle: { color: "#FFFFFF" },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }